import { TrendingUp } from "lucide-react";
import { useSelector } from "react-redux";
import Spinner from "../../../../Components/Loading/Spinner";

const statLinkClass =
  "text-[11px] text-blue-400 hover:underline cursor-pointer bg-transparent border-0 p-0 text-left";

function StatCard({ value, label, loading, trend, linkLabel, onLinkClick }) {
  return (
    <div className="bg-[#0F172A] border border-[#1a2744] rounded-xl p-5">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="text-[32px] text-white min-h-[40px] flex items-center" style={{ fontWeight: 800 }}>
            {loading ? <Spinner /> : value}
          </div>
          <div
            className="text-[11px] text-white/40 uppercase tracking-widest"
            style={{ fontWeight: 700 }}
          >
            {label}
          </div>
        </div>
        <div
          className="flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] bg-emerald-500/10 text-emerald-400"
          style={{ fontWeight: 600 }}
        >
          <TrendingUp className="w-3 h-3" />
          {trend}
        </div>
      </div>
      {linkLabel && (
        <button type="button" className={statLinkClass} style={{ fontWeight: 600 }} onClick={onLinkClick}>
          {linkLabel}
        </button>
      )}
    </div>
  );
}

const Hero = ({ setActive }) => {
  const orderData = useSelector((state) => state.AdminOrders.OrderData);
  const adminUsers = useSelector((state) => state.user.AdminAllUser);
  const isLoadingOrder = useSelector((state) => state.AdminOrders.OrderLoading);
  const isLoadingUsers = useSelector((state) => state.user.adminloading);

  const totalSale = orderData?.reduce((acc, item) => acc + (item?.totalAmount || 0), 0) ?? 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <StatCard
        value={adminUsers?.length ?? 0}
        label="Users"
        loading={isLoadingUsers}
        trend="9.5%"
        linkLabel="View All Users"
        onLinkClick={() => setActive(2)}
      />
      <StatCard
        value={orderData?.length ?? 0}
        label="Orders"
        loading={isLoadingOrder}
        trend="7.8%"
        linkLabel="View All Orders"
        onLinkClick={() => setActive(1)}
      />
      <StatCard
        value={`$${Math.floor(totalSale)}`}
        label="Total Sales Amount"
        loading={isLoadingOrder}
        trend="2.5%"
        linkLabel="View All Sales"
        onLinkClick={() => setActive(1)}
      />
    </div>
  );
};

export default Hero;
